var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUvai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 87,
    viewBox: "0 0 93 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7472 68.576C9.7024 68.576 6.656 67.5008 4.608 65.3504C2.56 63.1744 1.536 60.3072 1.536 56.7488V41.1584H8.3328V56.8256C8.3328 58.6176 8.8064 59.9744 9.7536 60.896C10.7264 61.8176 12.0576 62.2784 13.7472 62.2784C15.4368 62.2784 16.7552 61.8176 17.7024 60.896C18.6496 59.9744 19.1232 58.6176 19.1232 56.8256V41.1584H25.92V56.7488C25.92 60.3328 24.896 63.2 22.848 65.3504C20.8256 67.5008 17.792 68.576 13.7472 68.576ZM28.41 41.1584H35.6676L42.5028 59.0144L49.338 41.1584H56.5572L45.8436 68H39.162L28.41 41.1584ZM63.687 41.1584H70.3686L81.0822 68H74.1318L71.9814 62.4704H62.0742L59.9238 68H52.935L63.687 41.1584ZM70.2918 57.248L67.0278 48.224L63.7254 57.248H70.2918ZM83.778 41.1584H90.5748V68H83.778V41.1584Z",
    fill: "url(#paint0_linear_1379_3503)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.149 16.062H14.209L14.156 19.637L8.149 25.043V16.062ZM24.907 14.083L1 35.169L3.52 38L25.005 19.046L46.486 38L49 35.169L25.097 14.083L25 14L24.907 14.083Z",
    fill: "url(#paint1_linear_1379_3503)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8097 22.9585L67.7768 25.175L67.8017 23.5L67.8097 22.9585ZM74.4425 21.7315L59.6201 34.8048L61.1825 36.5601L74.5032 24.8086L87.8214 36.5601L89.3801 34.8048L74.5603 21.7315L74.5001 21.6801L74.4425 21.7315Z",
    fill: "url(#paint2_linear_1379_3503)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.2627 24.8186L48.2468 25.8911L48.2589 25.0806L48.2627 24.8186ZM51.4721 24.2249L44.3 30.5507L45.056 31.4L51.5015 25.7138L57.9458 31.4L58.7 30.5507L51.5291 24.2249L51.5 24.2L51.4721 24.2249Z",
    fill: "url(#paint3_linear_1379_3503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_3503",
    x1: 0.00000186138,
    y1: 29,
    x2: 104.179,
    y2: 68.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1379_3503",
    x1: 25,
    y1: 14,
    x2: 25,
    y2: 41.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1379_3503",
    x1: 74.5001,
    y1: 21.6801,
    x2: 74.5001,
    y2: 38.7921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1379_3503",
    x1: 51.5,
    y1: 24.2,
    x2: 51.5,
    y2: 32.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvai);
export default __webpack_public_path__ + "static/media/UVAI.4441e4162a0f6d9eb8d46808374f6240.svg";
export { ForwardRef as ReactComponent };